import { render } from "./RedCouponOpenPopover.vue?vue&type=template&id=fabc51d4&scoped=true"
import script from "./RedCouponOpenPopover.vue?vue&type=script&lang=js"
export * from "./RedCouponOpenPopover.vue?vue&type=script&lang=js"

import "./RedCouponOpenPopover.vue?vue&type=style&index=0&id=fabc51d4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fabc51d4"]])

export default __exports__